export default {
  groupName: 'capital-one',
  appName: 'Capital One Dashboard',
  baseRoute: '/dashboard/capital-one',
  label: 'Capital One Ad Effect Tracker Dashboard',
  home: '/slicer',
  image: 'capital-one.png',
  description: 'Capital One Ad Effect Tracker Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/CapitalOne/config/main.js